import React from 'react'
import { AccountPage } from '../presentation/AccountPage'
import { Footer } from '../presentation/Footer'
import { Header } from '../presentation/Header'

export const Account = () => {
  return (
    <div>
      <Header />
      <AccountPage />
      <Footer />
    </div>
  )
}